export default __webpack_public_path__ + "static/media/intro.3b6d7a96.mp3";